import React from "react";
import { WithAuth } from "../../components/Authorization/WithAuth";
import PrescriptionReport from "../../containers/PrescriptionReports/PrescriptionReport";
import "../../assets/sass/lbd/_prescription-report.scss";

const PrescriptionReportPage = () => {
  return (
    <WithAuth>
      <PrescriptionReport />
    </WithAuth>
  );
};

export default PrescriptionReportPage;
